import { createReducer, createAction } from '@reduxjs/toolkit';
import ReactNativeBlobUtil from 'react-native-blob-util';
import Share from 'react-native-share';
import RNFS from 'react-native-fs';
import moment from 'moment';

import { isWeb } from '@helpers';

import { getSasToken } from '@reducers/blobStorage';
import { eventInvoke } from '@reducers/utils';
import type { AppDispatch } from '@reducers/utils/types';
import type { FileConnectorState, FileUploadStatisticsData, UploadedErrorLogEvent } from './types';

// Re-export types for consumers
export type { FileConnectorState, FileUploadStatisticsData, UploadedErrorLogEvent } from './types';

const initState: FileConnectorState = {
  data: {},
  connected: false,
  updatedAt: null,
};

export const setFileConnectorData = createAction<FileUploadStatisticsData>('fileConnector/setFileConnectorData');
export const clear = createAction('clear');

let isWaitingFile = false;

export const requestForActionOnError = (action: string) => async (dispatch: AppDispatch) => {
  if (action === 'DownloadErrorLog') {
    isWaitingFile = true;
  }

  await eventInvoke({ eventName: 'RequestForActionOnError', connectionName: 'appHub' });
};

export const onUploadedErrorLog = (e: UploadedErrorLogEvent) => async (dispatch: AppDispatch) => {
  if (e.errorLogFileUrl && isWaitingFile) {
    const token = await dispatch(getSasToken());
    const url = `${e.errorLogFileUrl}?${token}`;
    if (isWeb) {
      window.open(url, '_blank');
    } else {
      const date = moment().format('YYYY-MM-DD_HH-mm-SS');
      console.log(date, 'date');
      ReactNativeBlobUtil.config({
        fileCache: true,
        path: ReactNativeBlobUtil.fs.dirs.DocumentDir + `/FileErrorLogs_${date}.csv`,
      })
        .fetch('GET', url.replace(/ /g, '%20'), { ignoreInterceptor: 'true' })
        .then(async (resp) => {
          const filePath = resp.path();
          let options = {
            type: 'application/csv',
            url: filePath,
          };
          await Share.open(options);
          await RNFS.unlink(filePath);
        })
        .catch((e) => {
          console.log(e, 'e');
        });
    }
    isWaitingFile = false;
  }
};

export default createReducer<FileConnectorState>(initState, {
  [setFileConnectorData.type]: (state, action: { payload: FileUploadStatisticsData }) => ({
    ...state,
    data: action.payload,
    connected: true,
    updatedAt: moment().format(),
  }),
  [clear.type]: () => {
    return initState;
  },
});
